import { createContext, useContext } from 'react';

import { AddToastFn } from '.';

export const ToastContext = createContext<AddToastFn>(() => {});

export const useToastContext = () => useContext(ToastContext);
